module.exports = __webpack_public_path__ + "HelveticaLightOblique.aead0d67403d52f91fd9.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaLightOblique.woff
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLightOblique.woff
// module chunks = styles